export default function Hero() {
  return (
    <section className="relative w-full min-h-[620px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20minimalist%20fashion%20lifestyle%20scene%20with%20carefully%20arranged%20sneakers%20hoodies%20and%20accessories%20on%20warm%20wooden%20surface%2C%20soft%20diffused%20natural%20light%20from%20large%20window%2C%20cream%20and%20terracotta%20warm%20tones%2C%20clean%20aesthetic%2C%20editorial%20product%20photography%2C%20shallow%20depth%20of%20field%2C%20gentle%20organic%20shadows%2C%20luxurious%20yet%20approachable%20composition&width=1800&height=800&seq=hero-main-v2&orientation=landscape"
          alt="Basetao Spreadsheet lifestyle background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/35"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center py-20">
        <div className="mb-6">
          <span className="inline-block px-4 py-1.5 bg-primary-500/90 text-white text-xs font-semibold rounded-full tracking-wider uppercase">
            Updated 2026 Guides
          </span>
        </div>

        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
          Basetao Spreadsheet
          <br />
          <span className="text-white/90 font-normal text-2xl md:text-4xl lg:text-5xl">
            The Complete Guide For Smarter Shopping
          </span>
        </h1>

        <p className="text-white/80 text-sm md:text-lg max-w-2xl mx-auto mb-10 leading-relaxed">
          Discover verified Basetao Spreadsheet resources, product guides, shipping calculators,
          warehouse tips, coupons and expert reviews — all in one place.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-white font-semibold rounded-md hover:bg-primary-600 transition-all text-sm whitespace-nowrap"
          >
            Basetao Spreadsheet
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3.5 bg-white/95 text-foreground-900 font-semibold rounded-md hover:bg-white transition-all text-sm whitespace-nowrap"
          >
            Buy It Now
          </a>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-4 md:gap-8">
          {[
            { icon: 'ri-checkbox-circle-line', text: 'Updated 2026 Guides' },
            { icon: 'ri-team-line', text: 'Community Verified' },
            { icon: 'ri-file-text-line', text: 'Free Templates' },
            { icon: 'ri-ship-line', text: 'Shipping Info' },
          ].map((badge) => (
            <div key={badge.text} className="flex items-center gap-2 text-white/70 text-xs md:text-sm">
              <span className="w-5 h-5 flex items-center justify-center">
                <i className={`${badge.icon} text-white/60`}></i>
              </span>
              <span className="whitespace-nowrap">{badge.text}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}